import request from "../utils/api";
import MediaServerPeer from "../ms-peer";
import LocalUser from "../ms-peer/user/local";
import { nanoid } from "nanoid";
import { action, makeObservable, observable } from "mobx";

type UserInfo = { contactId: string }

class Store {

  url = "https://mediaserver.greendata.store" //"http://srv-svc-001.greendatasoft.local:8000"
  peer = new MediaServerPeer<UserInfo>()

  roomInfo: { uuid: string } | null = null

  constructor() {
    this.peer.currentUser = new LocalUser({ contactId: nanoid() })
    this.peer.currentUser.createStream = this.createStream

    makeObservable(this, {
      roomInfo: observable,
      setRoomInfo: action
    })
  }

  init() {
    this.connect()
    return () => this.peer.disconnect()
  }

  async connect() {
    const { token, roomInfo } = await request(this.url+"/rooms/test", { roomInfo: { uuid: nanoid(4) }, userInfo: { contactId: 1 } })
    this.peer.connect(this.url.replace("http", "ws"), token)
    this.setRoomInfo(roomInfo)
  }

  async createStream(streamName: string, constraints: { audio?: boolean, video?: boolean }) {
    try {
      if (streamName === "") {
        return await navigator.mediaDevices.getUserMedia(constraints)
      }

      if (streamName === "screenSharing") {
        console.log(streamName, constraints)
        return await navigator.mediaDevices.getDisplayMedia(constraints) 
      }
    }catch(e) {
      return null
    }

    return null
  }

  setRoomInfo (roomInfo: typeof this.roomInfo) {
    this.roomInfo = roomInfo
  }
}

export default Store